import React, { Component } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import ShowModalPopUp from '../ShowModalPopUp';
import {filecontactsUpload, closeModalPopUp} from '../FileUpload/fileUploadAction'
import _ from 'lodash';
class UploadContactsindex extends Component {
  constructor(props){
    super(props)
    this.state={
      inputFiles: null
    }
  }
  filehandler = (e) => {
    
    this.setState({inputFiles:e.target.files[0]})
  }
  onUpload =() =>{
    const {inputFiles} = this.state
    const formData = new FormData()
    formData.append('file', inputFiles);
    this.props.filecontactsUpload(formData)
  }
  validate = () =>{
    if((this.state.inputFiles) && !_.isNull(this.state.inputFiles)){
      return true
    }
  }
  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }  
    
    return(
    <div  className={(style) ? 'user' : "userSmall"}>
     <div className='margingap'>
     {(this.props.showerror === true) ?
      <ShowModalPopUp message={this.props.errmessage} 
      falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
      {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
      <input type='file' onChange={(e)=>this.filehandler(e)} /> 
      <Button className='buttonwidth' disabled={!this.validate()} onClick={this.onUpload}>Upload</Button>
     </div>
   </div>
   )   
  }
}
function mapStateToProps(state){
  return{    
    size: state.UserReducer.large,
    showerror:  state.fileUploadReducer.showerror, 
    errmessage:  state.fileUploadReducer.errmessage,
    isPending: state.fileUploadReducer.isPending
  }  
}

const mapDispatchToProps = (dispatch) => ({
  filecontactsUpload: (a) =>dispatch(filecontactsUpload(a)),  
  closeModalPopUp:  (a) =>dispatch(closeModalPopUp(a)), 
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadContactsindex);
